import React, { memo } from 'react';
import cn from 'classnames';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';

import commonStyles from '@styles/common.module.scss';

import styles from '../SelectedAssetInfo.module.scss';

interface IParameterProps {
	handleClickInfoIcon?: (param: string) => void;
	isExtraInfoOpened?: boolean;
	isPrice?: boolean;
	isStatus?: boolean;
	name: string;
	statusClassname?: string;
	value?: string | number | boolean;
	withInfoIcon?: boolean;
}

const Parameter = ({
	handleClickInfoIcon,
	isExtraInfoOpened,
	isPrice,
	isStatus,
	name,
	statusClassname,
	value,
	withInfoIcon,
}: IParameterProps) => {
	const withInfoClassname = cn({
		[styles.withInfoIcon]: withInfoIcon,
	});
	const infoIconClassname = cn(commonStyles.infoIcon, {
		[commonStyles.activeIcon]: isExtraInfoOpened,
	});

	const handleClick = () => handleClickInfoIcon && handleClickInfoIcon(name);

	return (
		<div className={styles.columnedInfo}>
			<div>{name}</div>
			<div className={withInfoClassname}>
				{isStatus
					? ''
					: value || 'N/A'
				}
				{isStatus && (
					<div className={statusClassname} />
				)}
				{withInfoIcon && (
					<Tooltip
						content={<span>Click to see details</span>}
						isDisabled={isExtraInfoOpened}
					>
						<div
							className={infoIconClassname}
							onClick={handleClick}
						>
							<DynamicIconWrapper icon={Icons.info} />
						</div>
					</Tooltip>
				)}
				{value && isPrice && <span className={styles.extraInfo}>(annually)</span>}
			</div>
		</div>
	);
};

export default memo(Parameter);
